export class PaymentModel {
	public total: number = 0;
	public type: string = null;
	public value: number;
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/payment/payment.model.ts